exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".handle-in-time[data-v-7c38158d] {\n  padding: 20px;\n  background-color: #edf4ff;\n  border-radius: 10px;\n}\n.handle-in-time .star[data-v-7c38158d] {\n  width: 20px;\n  height: 20px;\n  margin-right: 5px;\n}\n.handle-in-time .list .list-item[data-v-7c38158d] {\n  padding: 10px 15px;\n  margin-bottom: 10px;\n  border-radius: 5px;\n  background-color: #fff;\n}\n.handle-in-time .list .list-item .rank-icon[data-v-7c38158d] {\n  width: 20px;\n  height: 20px;\n  margin-right: 10px;\n}\n.handle-in-time .bottom-text[data-v-7c38158d] {\n  line-height: 1.5;\n}\n", ""]);

// exports
